import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "CompleteProfileContainer" */ './container/CompleteProfileContainer')
);
